import '@styles/main.scss';
import PostMod from './util/elementor-post-mod';
import TeamSwiper from './components/team-swiper';
import SuccessStoriesSwiper from './components/success-stories-swiper';
import SuccessStoriesFullSwiper from './components/success-stories-full-swiper';
import menu from './components/menu';

class App {
    constructor() {
        new PostMod();
        new TeamSwiper();
        new SuccessStoriesSwiper();
        new SuccessStoriesFullSwiper();
        menu();
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new App();
});
